/* eslint-disable react/prop-types */
import React from "react";
import { makeStyles, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import _ from "lodash";
import getReducedHistorics from "lib/utils/historics";
import { nFormatter } from "lib/utils";
import CardComponent from "app/common/CardComponent";
import moment from "moment";
import VolumeChartComponent from "./VolumeChartComponent";
import ExplicabilityComponent from "../../explicability-info/ExplicabilityComponent";

const useStyles = makeStyles((theme) => ({
  aggregateContainer: {
    display: "flex",
    alignItems: "center",
    marginLeft: "5px",
  },
  chartContainer: {
    position: "relative",
    overflow: "hidden",
    flexGrow: "1",
    [theme.breakpoints.up("xs")]: {
      height: "155px",
    },
    [theme.breakpoints.up("sm")]: {
      height: "200px",
    },
    [theme.breakpoints.up("md")]: {
      height: "300px",
    },
    [theme.breakpoints.up("lg")]: {
      height: "100%",
    },
  },
  componentTitle: {
    fontWeight: "bold",
    fontSize: "14px",
    [theme.breakpoints.up("xl")]: {
      fontSize: "16px",
    },
  },
}));

function HistoryVolumeComponent({ historics, salesPoints, historicsDataYoY }) {
  const classes = useStyles();
  const metadataSlice = useSelector((state) => state.metadata);

  const reducedFilteredHistorics = getReducedHistorics(historics);

  const xLabels = _.uniq(
    _.map([...historics, ...salesPoints], (el) => {
      return moment(el.date).format("MMM'YY");
    })
  );

  const volumeUnit = metadataSlice.all.units[0].unit;

  const getNStoresData = () => {
    const groupedSalePointsByDate = _.groupBy(salesPoints, "date");
    return _.map(Object.keys(groupedSalePointsByDate), (salePoint) => {
      return _.reduce(
        groupedSalePointsByDate[salePoint],
        (acc, curr) => {
          return {
            x: acc.x,
            y: acc.y + curr.distinct_count_point_of_sale_id,
          };
        },
        { x: moment(salePoint).format("MMM'YY"), y: 0 }
      );
    });
  };

  const marginData = {
    labels: xLabels,
    datasets: [
      {
        label: "Sell out",
        yAxisID: "units",
        type: "line",
        fill: false,
        borderColor: "#47B5DB",
        hoverBorderColor: "#47B5DB",
        hoverBorderWidth: 3,
        pointBordercolor: "#47B5DB",
        pointBackgroundColor: "#ffffff",
        backgroundColor: "#47B5DB",
        pointHoverBackgroundColor: "#ffffff",
        pointHoverRadius: 6,
        unit: volumeUnit,
        data: _.map(historics, (historic) => {
          return {
            x: moment(historic.date).format("MMM'YY"),
            y: historic.sum_units,
          };
        }),
      },
      {
        label: "Sell In",
        yAxisID: "units",
        type: "line",
        fill: false,
        borderColor: "#006B99",
        hoverBorderColor: "#006B99",
        hoverBorderWidth: 3,
        pointBordercolor: "#006B99",
        pointBackgroundColor: "#ffffff",
        backgroundColor: "#006B99",
        pointHoverBackgroundColor: "#ffffff",
        pointHoverRadius: 6,
        borderDash: [5, 5],
        unit: volumeUnit,
        data: _.map(historics, (historic) => {
          return {
            x: moment(historic.date).format("MMM'YY"),
            y: historic.sum_units_in,
          };
        }),
      },
      {
        label: "N. Stores (Distrib.)",
        yAxisID: "distinct_count_point_of_sale_id",
        type: "bar",
        borderColor: "#CCEEEB",
        pointBordercolor: "#CCEEEB",
        pointBackgroundColor: "#ffffff",
        backgroundColor: "#CCEEEB",
        data: getNStoresData(),
      },
    ],
  };

  return (
    <CardComponent
      title={
        <>
          <Typography variant="body1" className={classes.componentTitle}>
            {`Volume (${volumeUnit}) & Stores`}
            <ExplicabilityComponent tooltipText="Historical values for Volumes and number of stores in the last 12 months" />
          </Typography>
          <div className={classes.aggregateContainer}>
            <Typography variant="caption">Annual Aggregate</Typography>
            <Typography
              variant="subtitle2"
              style={{
                fontWeight: "bold",
                marginLeft: "10px",
              }}
            >
              {nFormatter(reducedFilteredHistorics.units)}
            </Typography>
          </div>
        </>
      }
      body={
        <div className={classes.chartContainer}>
          <VolumeChartComponent
            data={marginData}
            historicsDataYoY={historicsDataYoY}
          />
        </div>
      }
    />
  );
}

export default HistoryVolumeComponent;
